<!--
  Queue app header shared by both layouts: brand on the left, language switcher on the right.
-->
<header class="app-header">
  <div class="brand">
    <img class="brand-logo" src="images/logos/noleggiare-logo.png" alt="" aria-hidden="true" />
    <span class="brand-name">{{ "CUSTOMER.SHARED.APP_NAME" | translate }}</span>
  </div>

  <div class="actions">
    @if (fullscreenToggle(); as toggle) {
      <button type="button" class="header-fs-btn" aria-label="Toggle fullscreen" (click)="toggle()">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    }

    <app-language-switcher />
  </div>
</header>
